const selectors = {
  singleAccordion: "single-accordion",
  multiAccordion: "multi-accordion",
};
export default selectors;
